import { render, staticRenderFns } from "./WrongQuestions.vue?vue&type=template&id=88b0f5b0&scoped=true"
import script from "./WrongQuestions.vue?vue&type=script&lang=js"
export * from "./WrongQuestions.vue?vue&type=script&lang=js"
import style0 from "./WrongQuestions.vue?vue&type=style&index=0&id=88b0f5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b0f5b0",
  null
  
)

export default component.exports